import React, { useMemo, useState } from "react";
import { useUpdateUserModalOnboardingMutation } from "../../graphql/generated/graphql";
import { useAuth } from "../../hooks/useAuth";
import WelcomeModal from "../../components/adminDashboard/WelcomeModal/WelcomeModal";

const WELCOME_MODAL_KEY = "companionWelcome";

function WelcomeModalContainer() {
  const { meData, refetchMe } = useAuth();
  const [updateModalOnboarding] = useUpdateUserModalOnboardingMutation();
  const [isDismissed, setIsDismissed] = useState(false);

  const hasSeenWelcome = useMemo(() => {
    const modalOnboarding = meData?.me?.modalOnboarding || "";
    return modalOnboarding.split(",").includes(WELCOME_MODAL_KEY);
  }, [meData?.me?.modalOnboarding]);

  const handleDismiss = async () => {
    // Immediately hide the modal via local state
    setIsDismissed(true);

    const currentModalOnboarding = meData?.me?.modalOnboarding || "";
    const newValue = currentModalOnboarding ? `${currentModalOnboarding},${WELCOME_MODAL_KEY}` : WELCOME_MODAL_KEY;

    await updateModalOnboarding({
      variables: {
        modalOnboarding: newValue,
      },
    });

    // Refetch to update cache so modal stays hidden on navigation
    await refetchMe();
  };

  if (hasSeenWelcome || isDismissed) {
    return null;
  }

  return <WelcomeModal visible onDismiss={handleDismiss} />;
}

export default WelcomeModalContainer;
